import { ChakraProvider } from '@chakra-ui/react'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import store from '@core/app/store/store'
import { RecaptchaProvider } from '@core/utils/contexts/RecaptchaProvider/RecaptchaProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import '@core/utils/i18n'
import '../../index.css'
import { initSentry } from '@core/utils/sentry/initSentry'

import theme from '../../theme'

import { SignupPage } from './SignupPage'

initSentry()

const router = createBrowserRouter([
    {
        path: process.env.ENV === 'local' ? '' : '/sign-up',
        element: (
            <ThemeProvider>
                <RecaptchaProvider>
                    <SignupPage />
                </RecaptchaProvider>
            </ThemeProvider>
        ),
    },
])

const app = document.getElementById('root')
const root = createRoot(app!)

root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <RouterProvider router={router} />
            </ChakraProvider>
        </Provider>
    </>
)
